import { render, staticRenderFns } from "./APIdrawer.vue?vue&type=template&id=818595ca"
import script from "./APIdrawer.vue?vue&type=script&lang=js"
export * from "./APIdrawer.vue?vue&type=script&lang=js"
import style0 from "./APIdrawer.vue?vue&type=style&index=0&id=818595ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports